const PasswordType = {
  PASSWORD: 0,
  RECOVERY_PASSWORD: 1,
  REGISTER_PASSWORD: 2,
};

export default PasswordType;